import { IConverter } from "@tblabs/storage";
import { RawPlaylist, Playlist } from "../Models/Playlist";
import { Song } from "../Models/Song";


export class PlaylistConverter implements IConverter<RawPlaylist, Playlist>
{
    constructor(private allSongs: Song[]) 
    { }

    public FromRaw(raw: RawPlaylist): Playlist
    {
        const FindSong = (songId: string): Song | undefined => this.allSongs.find(song => song.Id === songId);
        const songs = raw.SongsIds.map(songId => FindSong(songId)).filter(song => song !== undefined);

        return new Playlist(raw.Id, raw.Name, songs);
    }

    public ToRaw(playlist: Playlist): RawPlaylist
    {
        return playlist.ToRaw();
    }
}
